import { render, staticRenderFns } from "./HowItWorksHBF.vue?vue&type=template&id=83cb27ee&scoped=true"
import script from "./HowItWorksHBF.vue?vue&type=script&lang=js"
export * from "./HowItWorksHBF.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksHBF.vue?vue&type=style&index=0&id=83cb27ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb27ee",
  null
  
)

export default component.exports